import axios from "axios";
import { useMutation } from "@tanstack/react-query";

const apiUrl = import.meta.env.VITE_API_URL;

const publicAuthHeaders = {
  AppVersion: "1.0.0",
  AppType: "web",
  DeviceType: "web",
};

export const postLogin = async ({ email, password }) => {
  const { data } = await axios.post(
    `${apiUrl}auth/login`,
    { email, password, isMobile: false },
    { headers: publicAuthHeaders },
  );
  return data;
};

export const postCheckEmail = async (email) => {
  const { data } = await axios.post(
    `${apiUrl}auth/check-email?email=${encodeURIComponent(email)}`,
    {},
    { headers: publicAuthHeaders },
  );
  return data;
};

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: postLogin,
  });
};

export const useCheckEmailMutation = () => {
  return useMutation({
    mutationFn: postCheckEmail,
  });
};
